<header data-test="header">
  <mat-toolbar class="header-top-row">
    <button mat-button (click)="navigate(environment.ecpCentralWebsiteBaseUrl)" class="header-top-row-button">
      <img alt="eyefinity logo" src="../../../../assets/images/Eyefinity_logo.svg" data-test="eyefinity-logo" />
    </button>
    <button [matMenuTriggerFor]="userNameMenu" class="user-name--button header-top-row-button" data-test="elab-button" id="username-menu" mat-button>
      <img alt="person icon" src="../../../../assets/images/person.svg" data-test="person-image" class="person-image" class="pb-1 pr-1" />
      {{ userName }}
      <mat-icon class="drop-down-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu class="sub-menu" #userNameMenu="matMenu" overlapTrigger="false" xPosition="after" yPosition="below">
      <button (click)="navigate(environment.ecpCentralWebsiteBaseUrl + '/greeting')" data-test="username-submenu-item" mat-menu-item class="sub-menu-button">
        Personalized Greeting
      </button>
      <button (click)="navigate(environment.ecpCentralWebsiteBaseUrl + '/accountSetting')" data-test="username-submenu-item" mat-menu-item class="sub-menu-button">
        Account Setting
      </button>
      <button (click)="navigate(getChangePasswordUrl())" data-test="changepassword-submenu-item" mat-menu-item class="sub-menu-button">Change Password</button>
    </mat-menu>

    <button (click)="logout()" mat-button class="logout-button header-top-row-button" data-test="logout-button">
      <mat-icon class="logout-icon">power_settings_new</mat-icon><span class="logout-label">Logout</span>
    </button>
  </mat-toolbar>
  <mat-toolbar class="top-nav" data-test="top-nav">
    <button (click)="navigate(environment.ecpCentralWebsiteBaseUrl)" data-test="home-button" id="header-home-link" mat-button class="top-nav-button">Home</button>
    <button [matMenuTriggerFor]="eInsuranceMenu" data-test="einsurance-button" id="header-legacy-eInsurance-link" mat-button class="top-nav-button">
      eInsurance
      <mat-icon class="drop-down-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu class="sub-menu" #eInsuranceMenu="matMenu" overlapTrigger="false" xPosition="after" yPosition="below">
      <button (click)="navigate(environment.eInsuranceWebsiteBaseUrl)" data-test="eInsurance-submenu-item" mat-menu-item class="sub-menu-button">eClaim</button>
      <button
        *ngIf="isVspProvider()"
        (click)="navigate(environment.modernEclaimWebsiteBaseUrl + '/claims-tracking')"
        data-test="eInsurance-submenu-item"
        mat-menu-item
        class="sub-menu-button">
        VSP Claim Tracking
      </button>
      <button
        (click)="navigate(environment.eInsuranceWebsiteBaseUrl + '/government-commercial/claim-tracking')"
        data-test="eInsurance-submenu-item"
        mat-menu-item
        class="sub-menu-button">
        Government & Commerical Claim Tracking
      </button>
      <button
        *ngIf="isVspProvider()"
        (click)="navigate(environment.eInsuranceWebsiteBaseUrl + '/vspOnline')"
        data-test="eInsurance-submenu-item"
        mat-menu-item
        class="sub-menu-button">
        VSPOnline
      </button>
      <button
        *ngIf="isVspProvider()"
        (click)="navigate(environment.modernEclaimWebsiteBaseUrl + '/auth-tracking')"
        data-test="eInsurance-submenu-item"
        mat-menu-item
        class="sub-menu-button">
        VSP Outstanding Authorizations
      </button>
    </mat-menu>
    <button [matMenuTriggerFor]="eLabMenu" class="active top-nav-button active-tab" data-test="elab-button" id="header-eLab" mat-button>
      eLab
      <mat-icon class="drop-down-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #eLabMenu="matMenu" class="sub-menu" overlapTrigger="false" xPosition="after" yPosition="below">
      <button (click)="navigate(environment.elabWebsiteBaseUrl)" data-test="elab-submenu-item" id="sub-header-eclaim-link" mat-menu-item class="sub-menu-button">eLab</button>
      <button [routerLink]="['lab-order/create']" data-test="elab-submenu-item" id="sub-header-eclaim-tracking-link" mat-menu-item class="sub-menu-button">Create Lab Order</button>
      <button [routerLink]="['lab-order/search']" data-test="elab-submenu-item" id="sub-header-vsp-online-link" mat-menu-item class="sub-menu-button">View Order Status</button>
      <button
        (click)="navigate(environment.elabWebsiteBaseUrl + '/vspone/technology-centers')"
        mat-menu-item
        data-test="elab-submenu-item"
        id="sub-header-claim-resource-center-link"
        class="sub-menu-button">
        VSPOne Lab
      </button>
      <button
        (click)="navigate(environment.elabWebsiteBaseUrl + '/vspone/redo-order')"
        data-test="elab-submenu-item"
        id="sub-header-auth-tracking-link"
        mat-menu-item
        class="sub-menu-button">
        Redo VSPOne Order
      </button>
    </mat-menu>

    <button (click)="redirectToEBuy()" data-test="ebuy-button" id="header-eBuy" mat-button class="top-nav-button">eBuy</button>

    <button [matMenuTriggerFor]="eLearnMenu" class="top-nav-button" data-test="elearn-button" id="header-eLearn" mat-button>
      eLearn
      <mat-icon class="drop-down-arrow">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #eLearnMenu="matMenu" class="sub-menu" overlapTrigger="false" xPosition="after" yPosition="below">
      <button (click)="navigate(environment.elearnWebsiteBaseUrl)" data-test="elearn-submenu-item" id="sub-header-elearn-link" mat-menu-item class="sub-menu-button">eLearn</button>
      <button
        (click)="navigate(environment.elearnWebsiteBaseUrl + '/icd10')"
        data-test="elearn-submenu-item"
        id="sub-header-elearn-icd10-link"
        mat-menu-item
        class="sub-menu-button">
        ICD-10 Overview
      </button>
    </mat-menu>

    <button [routerLink]="" data-test="eweb-button" id="header-eWeb" mat-button class="top-nav-button">eWeb</button>

    <div class="top-nav-right ms-auto" data-test="greeting-container">
      <a class="feedback-link" href="#" (click)="openFeedbackDialog(); $event.preventDefault()" data-test="provide-feedback-link" aria-label="Provide Feedback" tabindex="0">
        <img src="/assets/images/feedbackIcon.svg" alt="feedback" class="feedback-icon" width="24" height="24" />
        <span>Provide Feedback</span>
      </a>
      <span class="greeting-text" id="greeting-text" data-test="greeting-text">
        {{ greeting }}
      </span>
    </div>
  </mat-toolbar>
</header>
